import React from 'react';
import { PropTypes } from 'prop-types';
import { formatters as addressFormatters } from 'utils/addresses';
import { Icon } from '@ontruck/orc';
import { useTranslation } from 'react-i18next';

const StatusText = ({ subTitle }) => {
  const { t } = useTranslation('OrderStop');
  const { style, icon, value, address, estimatedTime, driverName } = subTitle;

  if (!value && !driverName && !icon) {
    return null;
  }

  const renderStopName = () => {
    if (driverName) {
      return driverName;
    }

    return t(`label.${value || ''}`, {
      address: addressFormatters.getAddressLabel(address),
      estimatedTime,
    });
  };

  const text = renderStopName();

  return (
    <span title={text} className={`status-text ${style || ''}`}>
      {!!icon && (
        <Icon glyph={`${icon || 'success'}`} color="primary500" size="18px" />
      )}
      {text}
    </span>
  );
};

StatusText.propTypes = {
  subTitle: PropTypes.shape({
    style: PropTypes.string,
    icon: PropTypes.bool,
    value: PropTypes.string,
    driverName: PropTypes.string,
  }).isRequired,
};

export default StatusText;
